import { z } from "zod";

export const consentDocumentFileResponseSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  deleted_at: z.string().optional(),
  path: z.string(),
});

export const consentDocumentResponseSchema = z.object({
  id: z.uuid(),
  organization_id: z.uuid(),
  name: z.string(),
  files: z.array(consentDocumentFileResponseSchema),
});

export const acknowledgeConsentFormSchema = z.object({
  consent: z.boolean().refine((val) => val === true, {
    error: "You must acknowledge consent to continue.",
  }),
});
